import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsRolExternalService } from './edit-dialogs-rolexternal.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { EditDialogsTextsComponent } from '../../../texts/dialogs-texts/edit-dialogs-texts/edit-dialogs-texts.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { Utils } from 'src/app/core/utils/utils';
import { Texts } from 'src/app/core/entities/texts.model';

@Component({
  selector: 'app-edit-dialogs-rolexternal',
  templateUrl: './edit-dialogs-rolexternal.component.html',
  styleUrls: ['./edit-dialogs-rolexternal.component.css']
})
export class EditDialogsRolexternalComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsRolExternalService: EditDialogsRolExternalService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsRolexternalComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsRolExternalService.build(); }

  ngOnInit() {
    this.editDialogsRolExternalService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Rol externo
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsRolExternalService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del parameter está ausente
      // -1: El número del parameter ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorRolExternal('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorRolExternal('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog parameters
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let rolexternal = this.editDialogsRolExternalService.rolsExternal;
    let original = this.editDialogsRolExternalService.originalRolsExternal;
    return this.editDialogsRolExternalService.compare(rolexternal, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorRolExternal(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un rol external
  * @param parametro Opcional. Rol external a editar.
  */
  public editTextoAviso() {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let text: Texts = new Texts();
    text = _.cloneDeep(this.editDialogsRolExternalService.text);
    const dialogRef = this.dialog.open(EditDialogsTextsComponent, {
      width: '50%',
      disableClose: true,
      hasBackdrop: true,
      data: { text, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.ngOnInit();
      }, 1000);
    });
  }

}
